import { DateTime } from 'luxon'
import React, { useState } from 'react'
import formula from '../../assets/img/formula_icon.svg'
import ricarica from '../../assets/img/ricarica_icon.svg'
import bonus from '../../assets/img/bonus_icon.svg'
import canone from '../../assets/img/canone_icon.svg'
import sdd from '../../assets/img/SDD_icon.svg'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeSupport from '../Home/HomeSupport';
import { useSelector } from 'react-redux'
import GetAppIcon from '@mui/icons-material/GetApp';

function Item({id, emissione, scadenza, amount, reason, note, kwh, price, tag, url, filtered}) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedId, SetSelectedId] = useState(null)
    const iban = useSelector((user) => user.user.datiPagamento?.account_iban)
    const methodPay = useSelector((user) => user.user.datiPagamento.method_name)
    const token = useSelector((user) => user.user.datiPagamento?.token)
    const saldoIniziale  = useSelector((user) => user.user.ultimoSaldo)
    const toggleOpen = (id) => {
        setIsOpen(!isOpen)
        SetSelectedId(id)
    };

    const switchImage = () => {
        const tagValue = tag;
        const method = methodPay;
        switch(tagValue) {
            case 'ricarica':
              return <img src={ricarica} alt="ricarica" />;
            case 'consumi':
                return <img src={formula} alt="consumi" />;
            case 'bonus-sociale':
                return <img src={bonus} alt="bonus" />;
            case 'ricariche-bonus':
                return <img src={bonus} alt="bonus" />;
            case 'canone-rai':
                return <img src={canone} alt="canone rai" />;
            case 'incasso-sdd':
                return method === 'RID' ? <img src={sdd} alt="incasso sdd" /> : <img src={ricarica} alt="ricarica" />;
            default:
              return ;
        }
    }
    const switchNote = () => {
        const tagValue = tag;
        const method = methodPay;
        const ibanValue = iban;
        const tokenValue = token;

        switch(tagValue) {
            case 'canone-rai':
              return 'Non incide sul saldo';
            case 'consumi':
                return price ? parseFloat(price).toFixed(2).replace(/\./g, ",") + ' € x ' + kwh.toString().replace('-', '') + ' kWh' : 'Prezzo a kWh non ancora disponibile';
            case 'incasso-sdd':
                return method === 'RID' ? 'Iban: IT*****' + ibanValue.slice(ibanValue.length - 4) : '**** **** ****' + tokenValue.slice(tokenValue.length - 4);
            default:
              return note;
        }
    }
    const amountNumber = parseFloat(amount).toFixed(2).replace('-', '')
  
    return <>
        <div className="item" onClick={() => toggleOpen(id)}>
            {filtered ? (
                <div className="top" style={{marginBottom: '13px'}}>
                    <div className="date">
                        <p>{DateTime.fromISO(emissione, {locale: 'it'}).toFormat('LLLL y')}</p>
                    </div>
                    <div className="amount">
                        <p></p>
                    </div>
                </div>
            ) : null}
            
            <div className="body">
                <div className="img">
                    {switchImage()}
                </div>
                <div className="info">
                    <div className="info_date">
                      <p>{DateTime.fromISO(emissione, {locale: 'it'}).toFormat('EEEE dd')}</p>
                    </div>
                    <div className="top_info">
                        <p className="reason">{reason === 'Incasso SDD' ? reason.replace(reason, 'Ricarica Completata') : reason}</p>
                        <p className={amount.toString().includes('-') ? 'amount negative' : 'amount positive'}>{amount.toString().includes('-') ? amount.toString().replace(/\./g, ",") : '+ ' + amount.toString().replace(/\./g, ",")} €</p>
                    </div>
                    <div className="bottom_info">
                        <p className="note">
                            {switchNote()}
                        </p>
                        
                        {scadenza !== null && scadenza > DateTime.now().toISO() ? (
                            <div className="expiry">
                                <p>Scade il {DateTime.fromISO(scadenza).toFormat('D')}</p>
                            </div>
                        ) : null}
                        
                    </div>
                </div>
            </div>
        </div>
        {isOpen && <Content saldo={saldoIniziale} amountNumber={amountNumber} id={selectedId} toggle={isOpen} setToggle={toggleOpen} emissione={emissione} scadenza={scadenza} amount={amount} reason={reason} token={token} method={methodPay} note={switchNote()} img={switchImage()} tag={tag} url={url} iban={iban} />}
    </>;
}
function Content({saldo, amountNumber, toggle, setToggle, id, emissione, scadenza, amount, reason, note, img, tag, url, token, method, iban}) {
    return (
        <div className="contentDetails" style={toggle ? {display: 'block'} : {display: 'none'}}>
            <div className="go_back" onClick={setToggle}>
                <p><ArrowBackIosIcon />Torna ai movimenti</p>
            </div>
            <div className="header">
                <div className="img">
                    {img}
                </div>
                <div className="info">
                    <div className="info_date">
                        <p>{DateTime.fromISO(emissione, {locale: 'it'}).toFormat('EEEE dd')}</p>
                    </div>
                    <div className="top_info">
                        <p className="reason">{reason === 'Incasso SDD' ? reason.replace(reason, 'Ricarica Completata') : reason}</p>
                        <p className={amount.toString().includes('-') ? 'amount negative' : 'amount positive'}>{amount.toString().replace(/\./g, ",")} €</p>
                    </div>
                    <div className="bottom_info">
                        <p className="note">
                            {note}
                        </p> 
                        {scadenza !== null && scadenza > DateTime.now().toISO() ? (
                            <div className="expiry">
                                <p>Scade il {DateTime.fromISO(scadenza).toFormat('D')}</p>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
            {tag === 'consumi' && parseFloat(saldo) < parseFloat(amountNumber) ? (
                scadenza !== null && scadenza > DateTime.now().toISO() ? (
                    <div className="state">
                        <div className="title">
                            <p>Stato</p>
                        </div>
                        <div className="para">
                             <p>Il {DateTime.fromISO(scadenza).toFormat('D')} preleveremo {method === 'RID' ? 'dal tuo conto corrente ' :  'dalla tua carta '} {method === 'RID' ? (
                                     iban && 'Iban: '.concat('**', iban.slice(iban.length - 4))
                                 ) : (
                                     token && 'numero '.concat('**', token.slice(token.length - 4))
                                 )} un totale di {amount.toString().replace(/\./g, ",").replace('-', '')} €</p>
                         </div>
                    </div>
                ) : null
                // <div className="state">
                //     <div className="title">
                //         <p>Stato</p>
                //     </div>
                //     {scadenza !== null && scadenza > DateTime.now().toISO() ? (
                //         <div className="para">
                //             <p>Il {DateTime.fromISO(scadenza).toFormat('D')} preleveremo {method === 'RID' ? 'dal tuo conto corrente ' :  'dalla tua carta '} {method === 'RID' ? (
                //                     iban && 'Iban: '.concat('**', iban.slice(iban.length - 4))
                //                 ) : (
                //                     token && 'numero '.concat('**', token.slice(token.length - 4))
                //                 )} un totale di {amount.toString().replace(/\./g, ",").replace('-', '')} €</p>
                //         </div>
                //     ) :  (
                //         <div className="para">
                //             <p>Giorno {DateTime.fromISO(scadenza).toFormat('D')} abbiamo scalato {method === 'RID' ? 'dal tuo conto corrente ' :  'dalla tua carta '} {method === 'RID' ? (
                //                 iban && 'Iban: '.concat('**', iban.slice(iban.length - 4))
                //                 ) : (
                //                     token && 'numero '.concat('**', token.slice(token.length - 4))
                //                 )} un totale di {amount.toString().replace(/\./g, ",").replace('-', '')} €</p>
                //         </div>
                //     )}
                // </div>
            ) : null}
            
            <div className="details" style={parseFloat(saldo) < parseFloat(amountNumber) ? null : {marginTop: '15px'}}>
                <div className="dataItem">
                    <p className="title">Data</p>
                    <div className="detail">
                        <p className="content">{DateTime.fromISO(emissione).toFormat('EEEE dd MMMM y')}</p>
                        
                        {url && <a href={url}><GetAppIcon /> Fattura</a>}
                    </div>
                </div>
                <div className="dataItem">
                    {tag === 'ricarica' || tag === 'incasso-sdd' ? (
                        <>
                            <p className="title">Modalità di pagamento</p>
                            <div className="detail">
                                <p className="content">{method === 'RID' ? (
                                    iban && 'Prelievo da conto corrente '.concat('++', iban.slice(iban.length - 4))
                                ) : (
                                    token && 'Ricarica automatica su carta '.concat('**', token.slice(token.length - 4))
                                )}</p>
                            </div>
                        </>
                    ) : null}
                </div>
                <div className="dataItem">
                    {scadenza && (
                        <>
                            <p className="title">Data incasso</p>
                            <div className="detail">
                                <p className="content">{DateTime.fromISO(scadenza).toFormat('EEEE dd MMMM y')}</p>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <HomeSupport id={id} />
        </div>
    );
  }
export default Item
